export const prefixSlash = (path?: string): string =>
  typeof path !== 'undefined' && path.length > 0 && !path.startsWith('/') ? `/${path}` : `${path}`

export const isExternal = (path?: string): boolean =>
  typeof path !== 'undefined' && path.startsWith('http')
